import React from 'react'
import { ScrollView, TouchableOpacity, View } from 'react-native'
import { TopNavigationBar } from 'ui/common/top-navigation-bar'
import { colors } from 'infra/color'
import { observer } from 'mobx-react'
import { useSafeAreaInsets } from 'infra/util'
import { SearchInput } from 'ui/discovery/search-input'
import { Body2 } from 'ui/common/text'
import { CategoryChip } from 'ui/discovery/category-chip'
import { navigation } from 'navigation/global'
import { RowLayout } from 'ui/common/layout'
import { categorySelectStore } from 'store/category-select'

export const DiscoveryScreen = observer(() => {
  const safeAreaInsets = useSafeAreaInsets()
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: colors.white,
        paddingTop: safeAreaInsets.top,
      }}
    >
      <TopNavigationBar title='탐색하기' />
      <View style={{ height: 8 }} />
      <TouchableOpacity
        onPress={() => {
          navigation.navigate('SearchScreen')
        }}
      >
        <SearchInput editable={false} />
      </TouchableOpacity>
      <View style={{ height: 32 }} />
      <ScrollView
        style={{ paddingBottom: safeAreaInsets.bottom, paddingHorizontal: 30 }}
      >
        <Body2 style={{ color: colors.gray.v600, marginBottom: 12 }}>
          카테고리로 탐색
        </Body2>
        <RowLayout style={{ flexWrap: 'wrap' }}>
          {categorySelectStore.data.map((x) => (
            <CategoryChip
              key={x.id}
              isActive={true}
              isSelected={false}
              data={x}
              onPress={() => {
                categorySelectStore.selectL1Category(x)
                navigation.navigate('CategoryDiscoveryScreen')
              }}
            />
          ))}
        </RowLayout>
      </ScrollView>
    </View>
  )
})
